import { RouteConfig } from 'vue-router';

import { profileConfigRoute } from './settings/profileConfig.route';
import { settingsRoute } from './settings/settings.route';

export const settingsContainerRoute: RouteConfig = {
  path: 'settings',
  component: () =>
    import(/* webpackChunkName: "Router" */ '@/components/Router.vue'),
  children: [settingsRoute, profileConfigRoute]
};
